// extracted by mini-css-extract-plugin
export default {"roleWrapper":"RolesPermissions_roleWrapper__JM2bW","relatedItemWrapper":"RolesPermissions_relatedItemWrapper__y-idk","contextBtn":"RolesPermissions_contextBtn__3jSZG"};